// Shared date helpers used across the timekeeping app.
// Centralized here so all pages produce identical ISO date strings.

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function ndaysAgoISO(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}
